import React, {Component} from "react";
import AssociateFilterContextProvider from "./context/AssociateFilterContext";
import AssociatePerformanceContextProvider from "./context/AssociatePerformanceContext";
import CapabilityContextProvider from "../global/context/CapabilityContext";
import AssociateView from "./AssociateView";

class Associates extends Component {
    render() {
        return (
            <CapabilityContextProvider>
                <AssociateFilterContextProvider>
                    <AssociatePerformanceContextProvider>
                        <AssociateView history={this.props.history} associate={this.props.match.params.associate}/>
                    </AssociatePerformanceContextProvider>
                </AssociateFilterContextProvider>
            </CapabilityContextProvider>

        )
    }
}

export default Associates


// WEBPACK FOOTER //
// ./src/components/pickassociate/Associates.js